import axios from 'axios';
import { CONSTANTS } from '../../config/app-config';


export const RegistrationApi = async (request:any) => {
  let response: any;
  const version = CONSTANTS.VERSION;
  // const method = 'customer_signup';
  const method = 'customer_signup_web';
  const entity = 'registration';
  console.log(request, 'body');
  const params = `?version=${version}&method=${method}&entity=${entity}`;
  const encodedPassword = encodeURIComponent(request.confirm_password);
  let url: any
  if (request?.sales_person) {

     url = `${CONSTANTS.API_BASE_URL}${CONSTANTS.API_MANDATE_PARAMS}${params}&email=${request.email}&name=${request.name}&contact_no=${request.contact}&address=${request.address_1}&address_2=${request.address_2}&gst_number=${request.gst_number}&city=${request.city}&state=${request.state}&postal_code=${request.postal_code}&password=${encodedPassword}&territory=All Territories&sales_person=${request.sales_person}&user_type=${request.user_type}&associated_to=${request.associated_to}`
  }else{
     url = `${CONSTANTS.API_BASE_URL}${CONSTANTS.API_MANDATE_PARAMS}${params}&email=${request.email}&name=${request.name}&contact_no=${request.contact}&address=${request.address_1}&address_2=${request.address_2}&gst_number=${request.gst_number}&city=${request.city}&state=${request.state}&postal_code=${request.postal_code}&password=${encodedPassword}&territory=All Territories&user_type=${request.user_type}&associated_to=${request.associated_to}`

  }

  const config = {
    headers: {
      // Accept: 'application/json',
      'Content-Type': 'application/json' 
    },
  };
  //    const val= JSON.stringify(body)

  await axios
    .post(
      url,
      undefined,
      { ...config, timeout: 5000 }
    )
    .then((res) => {
      console.log(res, 'rrrr');
      response = res;
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        response = 'Request timed out';
      } else if (err.code === 'ERR_BAD_REQUEST') {
        response = 'Bad Request';
      } else if (err.code === 'ERR_INVALID_URL') {
        response = 'Invalid URL';
      } else {
        response = err;
      }
    });
  return response;
};

// const RegistrationApi = (request: any) => RegisterFetch(request);

// export default RegistrationApi;


// registrator_validate

export const registratorvalidate = async (request:any) => {
  let response: any;
  const version = CONSTANTS.VERSION;
  const method = 'registrator_validate';
  const entity = 'registration';
  console.log(request, 'body');
  const params = `?version=${version}&method=${method}&entity=${entity}`;
  let url: any
 
  let page_no = 0;
  let limit =  20;
  page_no = request?.page;
  page_no = (page_no!=undefined)?page_no:1;
  limit = request?.limit;

  let q = request?.q;
    
  let searchparams = (q!='' && q!=null)?`&q=${q}`:''

  url = `${CONSTANTS.API_BASE_URL}${CONSTANTS.API_MANDATE_PARAMS}${params}`
 
  const config = {
    headers: {
      // Authorization: token,
      // Accept: 'application/json',
      'Content-Type': 'multipart/form-data' 
    },
  };
  //    const val= JSON.stringify(body)

  await axios
    .post(
      url,
      request,
      { ...config, timeout: 5000 }
    )
    .then((res) => {
      console.log(res, 'rrrr');
      response = res?.data?.message;
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        response = 'Request timed out';
      } else if (err.code === 'ERR_BAD_REQUEST') {
        response = 'Bad Request';
      } else if (err.code === 'ERR_INVALID_URL') {
        response = 'Invalid URL';
      } else {
        response = err;
      }
    });
  return response;
};

//send_sms

export const get_otp = async (request:any) => {
  let response: any;
  const version = CONSTANTS.VERSION;
  const method = 'web_send_sms';
  const entity = 'otp';
  console.log(request, 'body');
  const params = `?version=${version}&method=${method}&entity=${entity}`;
  let url: any
 
  let page_no = 0;
  let limit =  20;
  page_no = request?.page;
  page_no = (page_no!=undefined)?page_no:1;
  limit = request?.limit;

  let q = request?.q;
    
  let searchparams = (q!='' && q!=null)?`&q=${q}`:''

  url = `${CONSTANTS.API_BASE_URL}${CONSTANTS.API_MANDATE_PARAMS}${params}`
 
  const config = {
    headers: {
      // Authorization: token,
      // Accept: 'application/json',
      'Content-Type': 'multipart/form-data' 
    },
  };
  //    const val= JSON.stringify(body)

  await axios
    .post(
      url,
      request,
      { ...config, timeout: 5000 }
    )
    .then((res) => {
      console.log(res, 'rrrr');
      response = res?.data?.message;
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        response = 'Request timed out';
      } else if (err.code === 'ERR_BAD_REQUEST') {
        response = 'Bad Request';
      } else if (err.code === 'ERR_INVALID_URL') {
        response = 'Invalid URL';
      } else {
        response = err;
      }
    });
  return response;
};


export const verify_otp = async (request:any) => {
  let response: any;
  const version = CONSTANTS.VERSION;
  const method = 'verify_otp';
  const entity = 'otp';
  console.log(request, 'body');
  const params = `?version=${version}&method=${method}&entity=${entity}`;
  let url: any
 
  let page_no = 0;
  let limit =  20;
  page_no = request?.page;
  page_no = (page_no!=undefined)?page_no:1;
  limit = request?.limit;

  let q = request?.q;
    
  let searchparams = (q!='' && q!=null)?`&q=${q}`:''

  url = `${CONSTANTS.API_BASE_URL}${CONSTANTS.API_MANDATE_PARAMS}${params}`
 
  const config = {
    headers: {
      // Authorization: token,
      // Accept: 'application/json',
      'Content-Type': 'multipart/form-data' 
    },
  };
  //    const val= JSON.stringify(body)

  await axios
    .post(
      url,
      request,
      { ...config, timeout: 5000 }
    )
    .then((res) => {
      console.log(res, 'rrrr');
      response = res?.data?.message;
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        response = 'Request timed out';
      } else if (err.code === 'ERR_BAD_REQUEST') {
        response = 'Bad Request';
      } else if (err.code === 'ERR_INVALID_URL') {
        response = 'Invalid URL';
      } else {
        response = err;
      }
    });
  return response;
};
